module.exports = __webpack_public_path__ + "static/media/caro3.41f220d6.jpg";